import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'identText',
    standalone: false
})
export class IdentTextPipe implements PipeTransform {

  transform(value: string): string {
    return value?.replace(/\n/g, '<br/>')
  }

}
